export default __webpack_public_path__ + "static/litebar-6c3c93d6d45fdf2e1008391b6ec37ec1.jpg";